import * as three from 'three';
import { Box3 } from './box3';
import { farthestPair } from './farthest';
import { ReadonlyVec3 } from './readonly';
import { Vec3Like } from './vec-like';
import { Vec3 } from './vec3';

export class Sphere extends three.Sphere{
	public declare readonly center:Vec3;

	public constructor(center=new Vec3(), radius=0){
		super(center,radius);
	}

	public expandByPoints(points:Iterable<Vec3>){
		for(const p of points)
			this.expandByPoint(p);
	}

	public toBox(){
		return new Box3().expandByPoint(this.center).expandByScalar(this.radius);
	}
}

export namespace Sphere{
	export function contains(c:Vec3Like, r:number, p:Vec3Like){
		return (p.x-c.x)**2+(p.y-c.y)**2<=r*r;
	}

	export function fromPoints(points:Iterable<ReadonlyVec3>){
		const farthest=farthestPair(points);
		if(!farthest)
			return null;
		return new Sphere(farthest[0].clone().mean(farthest[1]),farthest[2]/2);
	}
}
